import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 sm:pt-40 lg:pt-56 pb-12 sm:pb-16 lg:pb-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-12 sm:mb-16 lg:mb-20 text-center">
            How It Works
          </h1>
          
          {/* Steps */}
          <div className="space-y-10 sm:space-y-12 lg:space-y-16 mb-16 sm:mb-20 lg:mb-24">
            <div className="border-l-4 border-red-600 pl-6 sm:pl-8">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">Access</h2>
              <p className="text-base sm:text-lg text-gray-700 font-normal leading-relaxed">
                Access is held by an individual and may be self-funded or sponsored by an organization. It defines responsibility — not usage.
              </p>
            </div>
            
            <div className="border-l-4 border-red-600 pl-6 sm:pl-8">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">Use</h2>
              <p className="text-base sm:text-lg text-gray-700 font-normal leading-relaxed">
                Members engage Halvera when coordination, access, or protection is needed. Often around travel — but not limited to it.
              </p>
            </div>
            
            <div className="border-l-4 border-red-600 pl-6 sm:pl-8">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">Payment</h2>
              <p className="text-base sm:text-lg text-gray-700 font-normal leading-relaxed">
                Access defines support. Personal usage is handled separately, keeping boundaries clean.
              </p>
            </div>
          </div>
          
          {/* Note on Leisure */}
          <div className="bg-gray-50 p-6 sm:p-8 lg:p-10 rounded-lg mb-8 sm:mb-10 lg:mb-12 text-center">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">A Note on Leisure</h3>
            <p className="text-lg sm:text-xl text-gray-700 font-normal">
              Leisure is optional. Disruption is not.
            </p>
          </div>
          
          {/* CTA */}
          <div className="text-center">
            <Link 
              to="/apply" 
              className="inline-flex items-center px-8 sm:px-10 py-3 sm:py-4 bg-red-600 text-white rounded-md text-sm sm:text-base font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
            >
              Apply for Access
              <i className="ri-arrow-right-line ml-2 text-lg"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
